// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class ActivityHistoryService {

  apiUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getActivityHistoryByUserId(
    id: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `activity-history/` + id;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  createActivityHistory(
    item: any
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `activity-history`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  updateActivityHistory(
    item: any,
    activityHistoryId: string = ''
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `activity-history/${activityHistoryId}`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }
  

}
